import {
  Divider,
  ThemeProvider,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Box,
  Button,
} from '@mui/material'
import ConfigLoader, {
  COGNITO_DOMAIN,
  CLIENT_ID,
  REDIRECT_URI,
  GOOGLE_PROVIDER,
} from './ConfigLoader'
import { OtpLogin } from './OtpLogin'
import styled from 'styled-components'
import theme from 'assets/theme'
import { PatternFormat } from 'react-number-format'
import brand from 'assets/images/parco-logo.svg'
// let localRedirectionURL =
//   '?redirect_to=' + window.location.origin + '/dashboard'
// console.log(localRedirectionURL)
// const REDIRECT_URI = window.location.origin + '/callback' + localRedirectionURL
// console.log(COGNITO_DOMAIN)
// console.log(CLIENT_ID)
// console.log(REDIRECT_URI)
// console.log(GOOGLE_PROVIDER)
const triggerGoogleLogin = () => {
  const authorizationUrl =
    `https://${COGNITO_DOMAIN}/oauth2/authorize?` +
    `response_type=code` +
    `&client_id=${CLIENT_ID}` +
    `&redirect_uri=${encodeURIComponent(REDIRECT_URI)}` +
    `&identity_provider=${GOOGLE_PROVIDER}` +
    `&scope=email+openid+profile+aws.cognito.signin.user.admin` +
    `&prompt=select_account`

  // Redirect the user to Cognito's authorization endpoint (which redirects to Google)
  // console.log(authorizationUrl)
  window.location.href = authorizationUrl
}

import KeyOutlinedIcon from '@mui/icons-material/KeyOutlined'
import PersonAddOutlinedIcon from '@mui/icons-material/PersonAddOutlined'
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined'
import PhoneAndroidOutlinedIcon from '@mui/icons-material/PhoneAndroidOutlined'
import { useState } from 'react'

import { OauthLogin } from './OauthLogin'
import { Link } from '@mui/material'
import AuthHelp from 'components/modals/modals/AuthHelp'

const handleLoginClose = () => {}

export const Login = () => {
  const [stepIndicator, setStepIndicator] = useState('')
  const [otpLoginMethod, setOtpLoginMethod] = useState('phone')

  const setLoginPhone = () => {
    setOtpLoginMethod('phone')
  }
  const setLoginEmail = () => {
    setOtpLoginMethod('email')
  }

  const [open, setOpen] = useState(false)
  const onClose = () => {
    setOpen(false)
  }
  const openHelp = () => {
    setOpen(true)
  }

  return (
    <ThemeProvider theme={theme}>
      <ConfigLoader />
      <Grid container>
        <Dialog
          open={true}
          aria-labelledby="login-dialog-title"
          aria-describedby="login-dialog-description"
          fullWidth
          sx={{
            '.MuiPaper-root': {
              padding: { xs: '48px 24px', sm: '60px' },
              borderRadius: '8px',
            },
          }}
        >
          <Box
            sx={{ paddingLeft: '8px', width: '240px', margin: '0px auto 24px' }}
            component="img"
            src={brand}
            alt="PARCO Logo"
          />
          <Box mx={2}>
            <OtpLogin
              stepIndicator={stepIndicator}
              setStepIndicator={setStepIndicator}
              otpLoginMethod={otpLoginMethod}
            />
          </Box>
          <Box mx={2} mt={2} display={stepIndicator}>
            <Typography variant="body2" textAlign="center">
              - OR -
            </Typography>
            <Box mt={2} sx={{ textAlign: 'center' }}>
              <Button
                // startIcon={<PhoneAndroidOutlinedIcon />}
                startIcon={
                  <img src="https://upload.wikimedia.org/wikipedia/commons/c/c1/Google_%22G%22_logo.svg" />
                }
                variant="contained"
                sx={[
                  {
                    fontSize: '15px',
                    padding: '10px 24px 9px',
                    backgroundColor: '#fff',
                    color: '#344767',
                    fontWeight: '500',
                    boxShadow: 'none',
                    textTransform: 'none',
                    width: '100%',
                    border: '1px solid #ddd',
                  },
                  {
                    '&:hover, &:focus, &:active, &:focus:not(:hover)': {
                      transform: 'none',
                      backgroundColor: '#f9f9f9',
                      boxShadow: 'none',
                    },
                  },
                ]}
                onClick={triggerGoogleLogin}
                autoFocus
              >
                Continue with Google
              </Button>
            </Box>
            {/* <Box mt={2} sx={{ textAlign: 'center' }}>
              <Button
                startIcon={<PhoneAndroidOutlinedIcon />}
                variant="contained"
                sx={[
                  {
                    fontSize: '15px',
                    padding: '10px 24px 9px',
                    backgroundColor: '#fff',
                    color: '#344767',
                    fontWeight: '500',
                    boxShadow: 'none',
                    textTransform: 'none',
                    width: '100%',
                    border: '1px solid #ddd',
                  },
                  {
                    '&:hover, &:focus, &:active, &:focus:not(:hover)': {
                      transform: 'none',
                      backgroundColor: '#f9f9f9',
                      boxShadow: 'none',
                    },
                  },
                ]}
                onClick={handleLoginClose}
                autoFocus
              >
                Continue with Facebook
              </Button>
            </Box> */}
            {otpLoginMethod === 'phone' && (
              <Box mt={2} sx={{ textAlign: 'center' }}>
                <Button
                  startIcon={<EmailOutlinedIcon />}
                  variant="contained"
                  sx={[
                    {
                      fontSize: '15px',
                      padding: '10px 24px 9px',
                      backgroundColor: '#fff',
                      color: '#344767',
                      fontWeight: '500',
                      boxShadow: 'none',
                      textTransform: 'none',
                      width: '100%',
                      border: '1px solid #ddd',
                    },
                    {
                      '&:hover, &:focus, &:active, &:focus:not(:hover)': {
                        transform: 'none',
                        backgroundColor: '#f9f9f9',
                        boxShadow: 'none',
                      },
                    },
                  ]}
                  onClick={setLoginEmail}
                  autoFocus
                >
                  Continue with Email
                </Button>
              </Box>
            )}
            {otpLoginMethod === 'email' && (
              <Box mt={2} sx={{ textAlign: 'center' }}>
                <Button
                  startIcon={<PhoneAndroidOutlinedIcon />}
                  variant="contained"
                  sx={[
                    {
                      fontSize: '15px',
                      padding: '10px 24px 9px',
                      backgroundColor: '#fff',
                      color: '#344767',
                      fontWeight: '500',
                      boxShadow: 'none',
                      textTransform: 'none',
                      width: '100%',
                      border: '1px solid #ddd',
                    },
                    {
                      '&:hover, &:focus, &:active, &:focus:not(:hover)': {
                        transform: 'none',
                        backgroundColor: '#f9f9f9',
                        boxShadow: 'none',
                      },
                    },
                  ]}
                  onClick={setLoginPhone}
                  autoFocus
                >
                  Continue with SMS Text
                </Button>
              </Box>
            )}
            <Box mt={2} sx={{ textAlign: 'center' }}>
              <Link href="/onboarding-flow">
                <Button
                  startIcon={<PersonAddOutlinedIcon />}
                  variant="contained"
                  sx={[
                    {
                      fontSize: '15px',
                      padding: '10px 24px 9px',
                      backgroundColor: '#fff',
                      color: '#344767',
                      fontWeight: '500',
                      boxShadow: 'none',
                      textTransform: 'none',
                      width: '100%',
                      border: '1px solid #ddd',
                    },
                    {
                      '&:hover, &:focus, &:active, &:focus:not(:hover)': {
                        transform: 'none',
                        backgroundColor: '#f9f9f9',
                        boxShadow: 'none',
                      },
                    },
                  ]}
                  onClick={handleLoginClose}
                  autoFocus
                >
                  Create Account
                </Button>
              </Link>
            </Box>
            <Typography
              variant="h6"
              textAlign="center"
              color={'#262627'}
              sx={{ textAlign: 'center' }}
              pt={2}
            >
              If you are having issues please{' '}
              <Button
                onClick={openHelp}
                variant="text"
                sx={{
                  padding: 0,
                  minWidth: 0,
                  textTransform: 'none',
                  transform: 'none',
                  fontSize: '16px',
                  marginTop: '-4px',
                  textDecoration: 'underline',
                }}
              >
                click here
              </Button>{' '}
              and we will reach out to you as soon as possible.
            </Typography>
          </Box>
        </Dialog>
        <AuthHelp open={open} onClose={onClose} setOpen={setOpen} />
      </Grid>
    </ThemeProvider>
  )
}
